import { useCallback, useEffect, useState } from "react"
import { getLocalUploadFileKey } from "./media/resourceUpload"

// start 每次调用都会重新开始计时，即使秒数与上次相同
export const useCountDown = () => {
  const [countdown, setCountdown] = useState(0)

  useEffect(() => {
    if (countdown <= 0) return

    const timer = window.setTimeout(() => {
      setCountdown((currentValue) => Math.max(currentValue - 1, 0))
    }, 1000)

    return () => {
      window.clearTimeout(timer)
    }
  }, [countdown])

  return { countdown, start: setCountdown }
}

export const useVideoCompressionProgress = () => {
  const [progressByFile, setProgressByFile] = useState<Record<string, number>>(
    {},
  )
  const progressValues = Object.values(progressByFile)
  const averageProgress = progressValues.length
    ? progressValues.reduce((total, progress) => total + progress, 0) /
      progressValues.length
    : undefined
  const updateProgress = useCallback((file: File, progress: number | null) => {
    const fileKey = getLocalUploadFileKey(file)

    setProgressByFile((currentValue) => {
      if (progress === null) {
        if (!(fileKey in currentValue)) return currentValue

        const nextValue = { ...currentValue }
        delete nextValue[fileKey]
        return nextValue
      }

      return {
        ...currentValue,
        [fileKey]: progress,
      }
    })
  }, [])

  return {
    averageProgress,
    updateProgress,
  }
}
